import React from 'react';
import { ZapIcon } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { PRICES } from '../data/content';
export function AlertBar() {
  return <div className="sticky top-0 z-50 w-full bg-plum-deep text-cream" data-id="element-16" data-mp="6bnzg4dad1b1">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-2 px-4 py-2.5 text-center" data-id="element-17" data-mp="3opnecqu7t0s7">
        <ZapIcon className="hidden h-4 w-4 shrink-0 text-gold sm:block" aria-hidden="true" data-id="element-18" data-mp="3tn5d5oeipzmh" />
        <p className="font-sans text-[11px] font-bold uppercase leading-tight tracking-[0.12em] sm:text-sm" data-id="element-19" data-mp="l7vfcshnvgki">
          Solo por hoy + 3 bonos gratis —{' '}
          <span className="text-gold" data-id="element-20" data-mp="b9fqyxa0qlep">
            solo por <PriceDisplay amount={PRICES.today} data-id="element-21" data-mp="b8nznyngf9u8" />
          </span>
        </p>
      </div>
    </div>;
}